import React, { useEffect, useLayoutEffect, useMemo, useRef, useState } from "react";
import { useTable } from "react-table";
import SquareCheckBox from "components/SquareCheckBox/index";
import MenuDropDown from "components/DropDowns/MenuDropDown/index";
import {
  menuList,
  trashList,
  sharedMenuList,
  ExternalSpaceList
} from "constants/Homepage/ysafe/menuList/list";

import Tabs from "components/Tabs/index";
import TabIcons from "constants/Homepage/ysafe/iconFunctions/tabIcons";
import ActionIcon from "constants/Homepage/ysafe/iconFunctions/actionIcon";
import useScreenMobile from "hooks/useScreen";

import folder from "../../../../assets/images/homepage/ySafe/tableIcons/folder.svg";
import pdf from "../../../../assets/images/homepage/ySafe/tableIcons/pdf.svg";
import xls from "../../../../assets/images/homepage/ySafe/tableIcons/xls.svg";

import "../table/table.scss";
import addFile from "assets/images/homepage/ySafe/addFile.png";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
// import RenameFile from "components/RenameFile/index";
import Drawer from "components/Drawer/index";
// import ShareProject from "../ShareProject/index";
// import FileInformation from "../FileInformation/index";
import VersionHistory from "../VersionHistory/index";
import DeleteModal from "components/DeleteModal/index";
import MoveFile from "components/MoveFile/index";
import ShareFiles from "../shareFiles/index";
import docs from "assets/images/fileImage/docs.svg";
import jpf from "assets/images/fileImage/jpg.svg";
import zip from "assets/images/homepage/ySafe/zip.svg";
import commonIcon from "assets/images/homepage/ySafe/commonFile.svg";
import ListIcons from "constants/Homepage/ysafe/menuList/listIconsFunc";
// import Portal from "../Portal";
import RestoreModal from "components/RestoreModal/index";
import Files from "../FileInformation/index";
import { File as IzFile, Folder as IzFolder } from "@induz/sdk";
import { Item, Task } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
import useTheme from "hooks/observer";
import BreadcrumbExternalShare from "./BreadCrumbExternal";
import PDFViewer from "components/PDFViewer/index";
import ImageViewer from "components/ImageViewer/index";
import AudioPlayer from "components/AudioPlayer/index";
import VideoPlayer from "components/VideoPlayer/index";
import { zipSync } from "fflate";

import CollaboraUI from "containers/CollaboraUI/CollaboraUI";
import { COLLABORA_URL, WOPI_URL, COLLABORA_STATE } from "URL/url";
import { getPin, getEmail } from "@induz/sdk";
import {
  fetchUserPlanTrashRetentionDays,
  formatTrashRetentionBanner
} from "utils/planTrashRetention";

const CHUNK_TIMEOUT = 60000; // 60s per 4MB chunk
const MAX_CHUNK_RETRIES = 3;

const withTimeout = (promise, ms, label = "Operation") => {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new Error(`${label} timed out after ${ms}ms`)),
      ms
    );
  });
  return Promise.race([promise, timeoutPromise]).finally(() =>
    clearTimeout(timeoutId)
  );
};

const SHEETS_APP_URL = "https://ysafe.io/sheets/";
const DOCS_APP_URL = "https://ysafe.io/docs/";

// Function to get file icon based on extension
const getFileIcon = (fileName, type) => {
  if (type === "folder") {
    return folder;
  }
  const extension = fileName?.split(".").pop().toLowerCase();
  switch (extension) {
    case "xls":
    case "xlsx":
    case "csv":
      return xls;
    case "pdf":
      return pdf;
    case "doc":
    case "docx":
      return docs;
    case "jpg":
    case "png":
    case "jpeg":
    case "svg":
      return jpf;
    case "zip":
      return zip;
    default:
      return commonIcon;
  }
};

const tabsTitles = [
  // "Recent",
  // "Shared Space Files and folders",
  //   "Shared with me",
  // "Favourites",
  //   "Trash"
];

const actionIconTitles = [
  "moveTo",
  "copy",
  "favorite",
  "download",
  "share",
  "restore",
  "delete"
];

const tabIconKeys = ["allFiles", "shared", /* "favourite", */ "trash"];
// const tabIconKeys = ["recent", "allFiles", "shared", "favourite", "trash"];

const Table = ({
  setTaskMonitorVisible,
  layout,
  count,
  setCount,
  checkedRows,
  setCheckedRows,
  filesData,
  searchQuery,
  uploadedFiles,
  setFilesData,
  selected,
  filteredFilesData,
  selectedRow,
  setSelectedRow,
  activeTab,
  setActiveTab,
  menu,
  setMenu,
  selectedModal,
  setSelectedModal,
  setCurrentPath,
  currentPath,
  fetchData,
  setSelectedFolder,
  selectedFolder,
  setSelectedFile,
  setModal,
  setFilesList,
  modal,
  taskManager,
  currentPage,
  setCurrentPage,
  totalPages,
  listedFolders,
  getReanderingList
}) => {
  // console.log("filesData in table test external", filesData);
  const showToast = useToast();
  const theme = useTheme();
  //   const [activeTab, setActiveTab] = useState(0);
  const [mobileRow, setMobileRow] = useState();
  //   const [selectedModal, setSelectedModal] = useState(null);
  const [subDropDown, setSubDropDown] = useState(false);
  const isMobile = useScreenMobile({ size: 768 });
  const [isEnoughSpaceBelow, setIsEnoughSpaceBelow] = useState(true);

  const [dupCurrentPath, setdupCurrentPath] = useState(currentPath);
  const [UUIDArrays, setUUIDArrays] = useState([]);
  const [showPDFViewer, setShowPDFViewer] = useState(false);
  const [fileOwner, setFileOwner] = useState("");
  const [trashRetentionBanner, setTrashRetentionBanner] = useState(() =>
    formatTrashRetentionBanner(null)
  );

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const days = await fetchUserPlanTrashRetentionDays();
        if (!cancelled) setTrashRetentionBanner(formatTrashRetentionBanner(days));
      } catch {
        if (!cancelled) setTrashRetentionBanner(formatTrashRetentionBanner(null));
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const [pdfFo, setPdfFo] = useState(null);
  const [pdfFileName, setPdfFileName] = useState("");
  const [pdfDupCurrentPath, setPdfDupCurrentPath] = useState([]);

  const [showImageViewer, setShowImageViewer] = useState(false);
  const [imageFo, setImageFo] = useState(null);
  const [imageFileName, setImageFileName] = useState("");
  const [imageDupCurrentPath, setImageDupCurrentPath] = useState([]);

  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [audioFo, setAudioFo] = useState(null);
  const [audioFileName, setAudioFileName] = useState("");
  const [audioDupCurrentPath, setAudioDupCurrentPath] = useState([]);

  const [showVideoPlayer, setShowVideoPlayer] = useState(false);
  const [videoFo, setVideoFo] = useState(null);
  const [videoFileName, setVideoFileName] = useState("");
  const [videoDupCurrentPath, setVideoDupCurrentPath] = useState([]);
  // Pagination states (unique to TableTest)

  //  variables for handling collabra
  const [showCollabora, setShowCollabora] = useState(false);
  const collaboraURL = useRef("");



  useEffect(() => {
    if (currentPath.length === 0) {
      setdupCurrentPath([]);
    }
  }, [currentPath]);


  useEffect(() => {
    if (filesData && Array.isArray(filesData)) {
      const uuidsArr = filesData.map(file => file.uuids).filter(Boolean);
      // console.log("UUIDarrays in table text.js", uuidsArr);
      setUUIDArrays(uuidsArr);
    }
  }, [filesData]);

  useEffect(() => {// TODO:understand the below logic and change it accordingly for external spaces
    // if (currentPath.length === 0 && activeTab + 1 === 2) {
    //   setCurrentPath((prev) => (prev.includes("shared") ? prev : [...prev, "shared"]));
    // }
    // TODO:Since there is only one active tab for external spaces,deactivate this logic
  }, [activeTab, currentPath, setCurrentPath]);
  const handledupFolderClick = (folderName) => {
    // console.log("handle dup folder click called with folder name ", folderName, " dup current path ", dupCurrentPath);
    setdupCurrentPath((prev) => [...prev, folderName]);
  };
  const handleFolderClick = (folderName) => {
    // console.log("handle folder click called with folder name ", folderName, " current path ", currentPath);
    setCurrentPath((prev) => [...prev, folderName]);

  };
  //  const [menu, setMenu] = useState({
  //    selectedRow: null,
  //    selectedOption: ""
  //  });

  const [mobileRowData, setMobileRowData] = useState({});
  const menuRef = useRef(null);

  // Calculate table menu position synchronously before paint to prevent visual jump
  // This refines the position based on actual rendered menu height
  useLayoutEffect(() => {
    if (layout === "table" && menu.selectedRow && menuRef.current) {
      try {
        const menuRect = menuRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        const menuTop = menuRect.top;
        const distanceFromBottom = viewportHeight - menuTop;

        // ULTRA aggressive: Always open upward if:
        // 1. Menu is in bottom 60% of viewport (covers last 3-4 items), OR
        // 2. Less than 600px from bottom of viewport
        // This ensures CONSISTENT behavior - last 3-4 items always open upward
        const bottomPortionThreshold = viewportHeight * 0.4; // Bottom 60% of screen (above 40%)
        const distanceThreshold = 600; // 600px from bottom (covers more items)
        const isInBottomPortion = menuTop > bottomPortionThreshold;
        const isNearBottom = distanceFromBottom < distanceThreshold;

        // Only open downward if menu is in top 40% AND has enough space (600px+)
        if (!isInBottomPortion && !isNearBottom && distanceFromBottom >= distanceThreshold) {
          setIsEnoughSpaceBelow(true);
        } else {
          // In bottom 60% OR near bottom - ALWAYS open upward (consistent behavior)
          setIsEnoughSpaceBelow(false);
        }
      } catch (error) {
        console.error("Error calculating table menu position:", error);
        setIsEnoughSpaceBelow(false); // Default to opening above (no scrolling needed)
      }
    }
  }, [menu.selectedRow, layout]);

  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
        width: "95%", // was 35.1064% when Last Modified, Size, Owner were shown
        Cell: ({ row, cells }) => {
          return (
            <div className="nameColumn">
              <img
                src={getFileIcon(row.original.name, row.original.type)}
                alt="file icon"
                className="fileIcon"
              />
              <div className="iconNameBox">
                <span className="name">{row.original.name || "NoData"}</span>
              </div>
            </div>
          );
        }
      },
      // External share: only Name and Actions columns (Last Modified, Size, Owner commented out)
      // {
      //   Header: "Last Modified",
      //   accessor: "last_modified",
      //   width: "17.2872%",
      //   Cell: ({ row, cells }) => (
      //     <span className="modified">
      //       {!isMobile && (
      //         <>
      //           <div className="date">
      //             {row.original.last_modified_date || "NoData"}
      //           </div>
      //           <div className="time">
      //           </div>
      //         </>
      //       )}
      //       {layout == "grid" && (
      //         <div className="bytes">{row.original.size || "NoData"}</div>
      //       )}
      //     </span>
      //   )
      // },
      // {
      //   Header: "Size",
      //   accessor: "size",
      //   width: "12.837%",
      //   Cell: ({ row }) => (
      //     <span className="modified">
      //       {!isMobile && (
      //         <>
      //           <div className="date">{row.original.size || " "}</div>
      //           <div className="time">
      //           </div>
      //         </>
      //       )}
      //       {layout == "grid" && (
      //         <div className="bytes">{row.original.size || "NoData"}</div>
      //       )}
      //     </span>
      //   )
      // },
      // {
      //   Header: "Owner",
      //   accessor: "owner",
      //   width: "15.8%",
      //   Cell: ({ row }) => (
      //     <div
      //       className="ownerColumn"
      //       style={{
      //         display: "flex",
      //         alignItems: "center",
      //         justifyContent: "flex-start",
      //         gap: "6px",
      //         fontSize: "13px"
      //       }}
      //     >
      //       {row.original.img ? (
      //         <img
      //           src={row.original.img}
      //           alt="profile"
      //           className="ownerAvatar"
      //         />
      //       ) : (
      //         <div
      //           style={{
      //             height: "22px",
      //             width: "22px",
      //             background:
      //               row.original.owner == "you"
      //                 ? "var(--fill-brand-light)"
      //                 : "var(--stroke-grey-medium)",
      //             borderRadius: "50%",
      //             display: "flex",
      //             justifyContent: "center",
      //             alignItems: "center",
      //             fontSize: "11px"
      //           }}
      //         >
      //           <p>
      //             {row?.original?.owner
      //               ?.split(" ")
      //               .map((word) => word[0])
      //               .join("")}
      //           </p>
      //         </div>
      //       )}
      //       <span>{row.original.owner || "NoData"}</span>
      //     </div>
      //   )
      // },
      {
        Header: "Actions",
        accessor: "actions",
        width: "5%", // was 4.5213%
        //   width: "7.3582%",
        Cell: ({ row, column }) => (
          <div
            className="actionIconBox"
            onClick={(e) => {
              if (!e || !e.currentTarget) return;

              // For table view, calculate position BEFORE setting menu state
              // This prevents the dropdown from going down for last items
              if (layout === "table") {
                try {
                  const actionIconRect = e.currentTarget.getBoundingClientRect();
                  const viewportHeight = window.innerHeight;
                  const actionIconBottom = actionIconRect.bottom;
                  const distanceFromBottom = viewportHeight - actionIconBottom;

                  // ULTRA aggressive: Always open upward if:
                  // 1. Item is in bottom 60% of viewport (covers last 3-4 items), OR
                  // 2. Less than 600px from bottom of viewport
                  // This ensures CONSISTENT behavior - last 3-4 items always open upward
                  const bottomPortionThreshold = viewportHeight * 0.4; // Bottom 60% of screen (above 40%)
                  const distanceThreshold = 600; // 600px from bottom (covers more items)
                  const isInBottomPortion = actionIconBottom > bottomPortionThreshold;
                  const isNearBottom = distanceFromBottom < distanceThreshold;

                  // Only open downward if item is in top 40% AND has enough space (600px+)
                  if (!isInBottomPortion && !isNearBottom && distanceFromBottom >= distanceThreshold) {
                    setIsEnoughSpaceBelow(true);
                  } else {
                    // In bottom 60% OR near bottom - ALWAYS open upward (consistent behavior)
                    setIsEnoughSpaceBelow(false);
                  }
                } catch (error) {
                  console.error("Error calculating table menu position:", error);
                  // Default to opening above (safer - no scrolling needed)
                  setIsEnoughSpaceBelow(false);
                }
              }

              // Set the menu state
              setMobileRow(row.id);
              setMenu((prev) => ({ ...prev, selectedRow: row.id }));
              setMobileRowData(row?.original);
              // Ensure selectedRow is set for menu actions
              setSelectedRow(row?.original);
            }}
            style={{
              cursor: "pointer",
              border:
                checkedRows[row.original.name] &&
                layout == "table" &&
                "1px solid",
              borderColor:
                checkedRows[row.original.name] && "var(--stroke-grey-medium)"
            }}
          >
            <ActionIcon
              type="action"
              //   color={
              //     layout == "grid" && theme == "dark"
              //       ? "var(--text-grey-neutral)"
              //       : "var(--text-highlight)"
              //   }
              color="var(--text-grey-neutral)"
            />
          </div>
        )
      }
    ],
    [layout, isMobile]
  );
  // Pagination calculation (unique to TableTest)

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data: filesData });

  const pressTimerRef = useRef(null);
  const isLongPress = useRef(false);

  const [isSelectionMode, setIsSelectionMode] = useState(false); // Tracks if selection mode is active

  const handleTouchStart = (event, id) => {
    // event.preventDefault(); // Prevents ghost clicks on mobile
    event.stopPropagation();

    isLongPress.current = false;

    pressTimerRef.current = setTimeout(() => {
      isLongPress.current = true;
      setIsSelectionMode(true); // Enable selection mode on long press

      setCheckedRows((prev) => {
        const updatedCheckedRows = { ...prev, [id]: true };
        return updatedCheckedRows;
      });
    }, 500); // Increased delay for better long-press detection
  };

  const handleTouchEnd = () => {
    clearTimeout(pressTimerRef.current);
  };

  const handleMobileRowClick = (rowId) => {
    if (!isSelectionMode) return; // Prevent selection if long press hasn't been used first

    if (isLongPress.current) {
      isLongPress.current = false; // Ignore click if it was a long press
      return;
    }

    setCheckedRows((prev) => {
      const updatedCheckedRows = { ...prev };

      if (updatedCheckedRows[rowId]) {
        // Deselect row if already selected
        delete updatedCheckedRows[rowId];
      } else {
        // Select row if not selected
        updatedCheckedRows[rowId] = true;
      }

      // Check if all rows are deselected -> Reset selection mode
      if (Object.keys(updatedCheckedRows).length === 0) {
        setIsSelectionMode(false);
      }

      // Check if all rows are selected
      return updatedCheckedRows;
    });
  };

  const handleMenu = () => {
    setMenu({
      selectedRow: null,
      selectedOption: ""
    });
  };

  const handleCancelSubdropDown = () => {
    setSubDropDown(false);
  };

  useEffect(() => {
    const trueCount = Object.values(checkedRows).filter(Boolean).length;
    setCount(trueCount);
  }, [checkedRows]);

  // Defensive reset for stale move/copy modal state when checkbox selection changes.
  useEffect(() => {
    if (selectedModal === "copy" || selectedModal === "moveTo") {
      setSelectedModal(null);
    }
  }, [checkedRows]);

  // const menuRef = useRef(null);

  // const [rename, setRename] = useState("");
  // const [fileExtension, setFileExtension] = useState("");

  useEffect(() => {
    if (selectedRow?.name) {
      const lastDotIndex = selectedRow.name.lastIndexOf(".");
      if (lastDotIndex !== -1) {
        // setRename(selectedRow.name); // Set only the name
        // setFileExtension(""); // Store extension separately
      } else {
        // setRename(selectedRow.name);
        // setFileExtension(""); // No extension case
      }
    }
  }, [selectedRow]);

  useEffect(() => {
    setCheckedRows({});
  }, [activeTab]);

  useEffect(() => {
    setCheckedRows({});
  }, [currentPath]);


  // const changeHandler = (e) => {
  // setRename(e.target.value); // Only update the file name, not the extension
  // };

  // const removeAfterRename = async () => {
  //   try {
  //     // await init();
  //     // const wasmInstance = new IzWasm(URL);
  //     // const sourcePath =
  //     //   currentPath.length > 0
  //     //     ? "/" + currentPath.join("/")
  //     //     : currentPath.join("/");
  //     // const remove = await wasmInstance.remove(localStorage.getItem("mail"), [
  //     //   sourcePath + "/" + selectedFolder.name
  //     // ]);

  //     console.log({ remove });
  //   } catch (error) {
  //     showToast("Error renaming file or folder : " + error, "error");
  //     console.log("Error renaming file or folder", error);
  //   }
  // };

  // using the move method to rename the folder or file

  /*
  Error renaming file or folder : ReferenceError: Buffer is not defined

  */
  // const renameHandler = async () => {
  //   try {
  //     const sourcePath =
  //       "/" + currentPath.join("/") + "/" + selectedFolder.name;
  //     const fo = await Item.getItem(sourcePath, false);
  //     // console.log("fo is ", fo);
  //     ;
  //     await fo.rename(rename + fileExtension);
  //     // Fetch fresh data after successful rename to ensure UI is in sync
  //     await fetchData(currentPath);
  //   } catch (error) {
  //     showToast("Failed to rename", "error");
  //     await fetchData(currentPath);
  //   }
  // };

  // const saveHandler = async () => {
  //   const newName = rename + fileExtension;
  //   const oldName = selectedRow.name;

  //   // Temporarily update UI for immediate feedback
  //   setFilesData((prevFiles) =>
  //     prevFiles.map((file) =>
  //       file.name === oldName
  //         ? { ...file, name: newName }
  //         : file
  //     )
  //   );

  //   // Update checkedRows if the renamed item was selected
  //   setCheckedRows((prev) => {
  //     if (prev[oldName]) {
  //       const updated = { ...prev };
  //       delete updated[oldName];
  //       updated[newName] = true;
  //       return updated;
  //     }
  //     return prev;
  //   });

  //   // Await rename operation to complete
  //   await renameHandler();

  //   setRename("");
  //   setFileExtension("");
  //   setMenu({
  //     selectedRow: null,
  //     selectedOption: ""
  //   });
  // };

  // const cancelHandler = () => {
  //   // setRename("");
  //   // setFileExtension("");
  //   setMenu({
  //     selectedRow: null,
  //     selectedOption: ""
  //   });
  // };

  const [dragging, setDragging] = useState(false);

  // Handle file drop
  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);

    const droppedFiles = Array.from(event.dataTransfer.files);

    if (droppedFiles.length > 0) {
      setSelectedFile((prevFiles) => [...prevFiles, ...droppedFiles]); // Append new files
      setFilesList((prevFiles) => [...prevFiles, ...droppedFiles]);
      setModal(true);
    }
  };

  // Drag over handlers
  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragEnter = () => setDragging(true);
  const handleDragLeave = () => setDragging(false);

  // useEffect(() => {
  // const fileName = selectedRow.name;
  // const downloadData = async () => {
  //   if (menu.selectedOption === "Download") {
  //     try {
  //       await init();
  //       const wasmInstance = new IzWasm(URL); // IzWasm Instance
  //       const chunkSize = 8 * 1024 * 1024; //
  //       const formattedPath =
  //         currentPath?.length === 0 ? "/" : `/${currentPath?.join("/")}`;
  //       const org = await wasmInstance.get_buffer(
  //         localStorage.getItem("mail"),
  //         `${formattedPath}/${fileName}`,
  //         [],
  //         BigInt(0),
  //         BigInt(18 * chunkSize)
  //       );
  //       // (bucket_name, file_name, buffer, offset, length) where file is backend.go
  //       console.log("org", org);
  //     } catch (error) {
  //       console.error("Failed to get buffer:", error);
  //     }
  //   }
  // };
  // downloadData();
  // }, [menu.selectedOption]);
  // const moveToTrash = async () => {
  //   try {
  //     const fileName = "/" + currentPath.join("/") + "/" + selectedRow.name;
  //     const fo = await Item.getItem(fileName, false);
  //     await fo.remove(false);
  //     showToast("File/Folder moved to trash", "success");
  //     fetchData(currentPath);
  //     setMenu({ selectedRow: null, selectedOption: null });

  //   } catch (error) {
  //     showToast("Move to Trash failed", "error");
  //     console.error("Failed to remove object:", error);
  //     setMenu({ selectedRow: null, selectedOption: null });
  //   }
  // };

  const onAllSelectRemove = async () => {
    const folderPathArr = [];
    const fileName = currentPath.join("/");
    const keys = Object.keys(checkedRows);

    for (const key of keys) {
      if (key) {
        // Construct full path to each selected file/folder
        folderPathArr.push(
          (fileName.length === 0 ? "" : "/") + fileName + "/" + key
        );
      }
    }

    if (folderPathArr.length === 0) return;

    const masterTask = new Task(keys.length, `Deleting ${keys.length} item(s)`, "Deleting");
    taskManager.addRunningTask(masterTask);

    let successfulCount = 0;
    try {
      for (let i = 0; i < folderPathArr.length; i++) {
        const path = folderPathArr[i];
        const item = await Item.getItem(path, false);
        await item.remove();
        successfulCount++;
        masterTask.progress = Math.min(((i + 1) / keys.length) * 100, 99);
      }

      masterTask.progress = 100;
      masterTask.name = `Deleting ${successfulCount} item(s)`;
      taskManager.addCompletedTask(masterTask, 1);

      showToast("Selected files/folders moved to trash", "success");
      await fetchData(currentPath); // Refresh UI
      // Trigger global storage refresh so sidebar/profile storage update immediately
      window.dispatchEvent(new CustomEvent("storageUpdated"));
      setCheckedRows({});
      setMenu({ selectedRow: null, selectedOption: null });
    } catch (error) {
      if (keys.length > 1) {
        const failed = keys.length - successfulCount;
        masterTask.name = `Deleting ${successfulCount} item(s), ${failed} failed`;
      }
      masterTask.progress = 0;
      taskManager.addCompletedTask(masterTask, 2);
      showToast("Move to Trash failed: " + error, "error");
      console.error("Move to Trash failed", error);
      setMenu({ selectedRow: null, selectedOption: null });
    }
  };
  // Size threshold for zip vs individual downloads (1 GB)
  const ZIP_SIZE_LIMIT = 0.5 * 1024 * 1024 * 1024;

  // Fetches ALL items from a folder, paginating through all pages.
  // folder.getFolderList() only returns the first page.
  const forEachFolderItem = async (folder, dupCurrentPath, callback, onListed = null, shouldStop = null) => {
    // let firstPage;
    // console.log("dp currenpt path", dupCurrentPath);
    const firstPage = await folder.getSharedWithMeFolderList(false);
    if (onListed) onListed(folder);
    // console.log("dupcurrnepath", dupCurrentPath);
    // Proactively list subfolders on this page to learn their counts early
    if (onListed) {
      const subfolders = firstPage.filter(item => item instanceof IzFolder);
      await Promise.all(subfolders.map(async (sf) => {
        try {
          // if (dupCurrentPath[0] === "external_shared") {
          //   sf.getSharedWithMeFolderList(false);
          // } else {
          //   sf.getFolderList();
          // }
          await sf.getSharedWithMeFolderList(false);
          onListed(sf);
        } catch (e) { /* ignore */ }
      }));
    }

    for (const item of firstPage) {
      if (shouldStop?.()) return;
      await callback(item);
    }
    if (!folder.getTotalItems || !folder.getPageSize || !folder.getNextFolderList) return;
    const total = folder.getTotalItems();
    const pageSize = folder.getPageSize();
    if (!total || total <= pageSize) return;
    const totalPages = Math.ceil(total / pageSize);
    for (let page = 1; page < totalPages; page++) {
      if (shouldStop?.()) return;
      try {
        let pageItems;
        if (dupCurrentPath[0] === "external_shared") {
          pageItems = await folder.getNextSharedWithMeFolderList(page);
        } else {
          pageItems = await folder.getNextFolderList(page);
        }
        if (pageItems && pageItems.length > 0) {
          // Proactively list subfolders on subsequent pages too
          if (onListed) {
            const subfolders = pageItems.filter(item => item instanceof IzFolder);
            await Promise.all(subfolders.map(async (sf) => {
              try { await sf.getFolderList(); onListed(sf); } catch (e) { /* ignore */ }
            }));
          }
          for (const item of pageItems) {
            if (shouldStop?.()) return;
            await callback(item);
          }
        }
      } catch (err) {
        console.error(`Failed to fetch folder page ${page + 1}:`, err);
      }
    }
  };

  const getAllFolderItems = async (folder) => {
    // console.log("hre");
    let firstPage;
    if (currentPath[0] === "external_shared") {
      firstPage = await folder.getSharedWithMeFolderList(false);
    } else {
      firstPage = await folder.getFolderList();
    }
    if (!folder.getTotalItems || !folder.getPageSize || !folder.getNextFolderList) {
      return firstPage;
    }
    const total = folder.getTotalItems();
    const pageSize = folder.getPageSize();
    if (!total || total <= pageSize) {
      return firstPage;
    }
    const allItems = [...firstPage];
    const totalPages = Math.ceil(total / pageSize);
    for (let page = 1; page < totalPages; page++) {
      try {
        let pageItems;
        if (currentPath[0] === "external_shared") {
          pageItems = await folder.getNextSharedWithMeFolderList(page);
        } else {
          pageItems = await folder.getNextFolderList(page);
        }
        if (pageItems && pageItems.length > 0) {
          allItems.push(...pageItems);
        }
      } catch (err) {
        console.error(`Failed to fetch folder page ${page + 1}:`, err);
      }
    }
    return allItems;
  };

  const computeFolderSize = async (folder, sizeTask) => {
    const items = await getAllFolderItems(folder);
    let totalSize = 0;
    for (const item of items) {
      if (item instanceof IzFile) {
        const fileSize = await item.getSize();
        totalSize += fileSize;
        if (sizeTask) {
          sizeTask.fileCount = (sizeTask.fileCount || 0) + 1;
          sizeTask.taskDescription = `Preparing download... (${sizeTask.fileCount} files found)`;
        }
      } else if (item instanceof IzFolder) {
        totalSize += await computeFolderSize(item, sizeTask);
      }
    }
    return totalSize;
  };

  // Download folder contents — uses native FS API (dirHandle) when available,
  // otherwise downloads each file individually as a blob
  const downloadIzFolder = async (folder, parentDirHandle, dupCurrentPath, masterTask, overrideName) => {
    const folderName = overrideName || folder.getFolderName();
    if (!folderName || folderName === "/") {
      throw new Error("Invalid folder name");
    }
    // console.log("downloading folder", folderName, "dup path", dupCurrentPath);
    // If we have a native FS handle, create subdirectory and stream files into it
    const folderHandle = parentDirHandle
      ? await parentDirHandle.getDirectoryHandle(folderName, { create: true })
      : null;

    if (!masterTask._countedPaths) masterTask._countedPaths = new Set();

    await forEachFolderItem(folder, dupCurrentPath, async (item) => {
      if (masterTask.status === 3) return;
      if (item instanceof IzFile) {
        await downloadIzFile(item, item.getName(), folderHandle, dupCurrentPath, { masterTask, useBlobFallback: !folderHandle });
        if (masterTask.status === 3) return;
        masterTask.fileCount = (masterTask.fileCount || 0) + 1;
        if (masterTask.totalFileCount > 0) {
          masterTask.progress = Math.min(Math.floor((masterTask.fileCount / masterTask.totalFileCount) * 100), 99);
        }
        masterTask.taskDescription = `Downloaded ${masterTask.fileCount}/${masterTask.totalFileCount || "?"} files`;
      } else if (item instanceof IzFolder) {
        await downloadIzFolder(item, folderHandle, dupCurrentPath, masterTask);
      }
    }, (f) => {
      const key = (f.getParentPath?.() || "") + "/" + (f.getFolderName?.() || "");
      if (!masterTask._countedPaths.has(key)) {
        masterTask._countedPaths.add(key);
        masterTask.totalFileCount = (masterTask.totalFileCount || 0) + (f.getTotalItems() || 0);
      }
    }, () => masterTask.status === 3);
  };

  // --- Path 2: fflate zip (all browsers, folders under ZIP_SIZE_LIMIT) ---
  const collectFolderForZip = async (folder, prefix, zipData, dupCurrentPath, masterTask) => {
    const items = await getAllFolderItems(folder);
    for (const item of items) {
      if (item instanceof IzFile) {
        const fileData = await downloadIzFile(item, item.getName(), undefined, dupCurrentPath, { returnData: true, masterTask });
        zipData[prefix + item.getName()] = fileData;
      } else if (item instanceof IzFolder) {
        await collectFolderForZip(item, prefix + item.getFolderName() + "/", zipData, dupCurrentPath, masterTask);
      }
    }
  };

  const downloadIzFolderAsZip = async (folder, dupCurrentPath, precomputedSize, overrideName) => {
    const folderName = overrideName || folder.getFolderName();
    const totalSize = precomputedSize != null ? precomputedSize : await computeFolderSize(folder);
    const masterTask = new Task(totalSize, `Downloading ${folderName}`, "Downloading");
    taskManager.addRunningTask(masterTask);

    try {
      const zipData = {};
      await collectFolderForZip(folder, folderName + "/", zipData, dupCurrentPath, masterTask);

      masterTask.taskDescription = `Zipping ${folderName}`;
      const zipped = zipSync(zipData);

      const blob = new Blob([zipped], { type: "application/zip" });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `${folderName}.zip`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      taskManager.addCompletedTask(masterTask, 1);
    } catch (error) {
      taskManager.addCompletedTask(masterTask, 2);
      throw error;
    }
  };

  // --- Path 3: Individual blob downloads (very large folders) ---
  const downloadFolderFilesIndividually = async (folder, dupCurrentPath, masterTask) => {
    const items = await getAllFolderItems(folder);
    for (const item of items) {
      if (item instanceof IzFile) {
        await downloadIzFile(item, item.getName(), undefined, dupCurrentPath, { masterTask, useBlobFallback: true });
      } else if (item instanceof IzFolder) {
        await downloadFolderFilesIndividually(item, dupCurrentPath, masterTask);
      }
    }
  };

  const downloadIzFile = async (fo, fileName, dirHandle, dupCurrentPath, { returnData = false, masterTask = null, useBlobFallback = false } = {}) => {
    const totSize = await fo.getSize();

    const displayFileName = fo.getName();

    // Warn user if large file download without native FS support
    if (!window.showSaveFilePicker && !returnData && !dirHandle && totSize > ZIP_SIZE_LIMIT) {
      showToast("Large file download — your browser may struggle. Use Chrome/Edge for best experience.", "warning");
    }

    // Use master task if provided (folder download), otherwise create per-file task
    const dataTask = masterTask || new Task(totSize, `Downloading ${displayFileName}`, "Downloading");
    if (!masterTask) {
      taskManager.addRunningTask(dataTask);
    }

    try {
      const chunks = [];
      let writer;
      let fileStream;
      let useNativeFS = false;
      const currentFileName = fo.getName();

      // Mode 1: dirHandle provided — write file into a directory (folder download with native FS)
      if (dirHandle) {
        useNativeFS = true;
        const fileHandle = await dirHandle.getFileHandle(currentFileName, { create: true });
        fileStream = await fileHandle.createWritable();
        writer = fileStream;
      }
      // Mode 2: File System Access API — individual file save picker (skip if useBlobFallback)
      else if (window.showSaveFilePicker && !returnData && !useBlobFallback) {
        useNativeFS = true;
        const handle = await window.showSaveFilePicker({
          suggestedName: currentFileName
        });
        fileStream = await handle.createWritable();
        writer = fileStream;
      }
      // Mode 3: Blob fallback — accumulate chunks in memory
      else {
        writer = {
          write(chunk) {
            chunks.push(chunk);
          }
        };
      }

      const maxConcurrency = 12;
      let activeDownloads = 0;
      let nextOffset = 0;
      let errorOccurred = null;
      const chunkSize = 4 * 1024 * 1024;
      const downloadPool = [];
      let completedChunks = 0;
      const totalChunks = Math.ceil(totSize / chunkSize);
      let path = fo.getParentPath() + "/" + fo.getName();
      if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "external_shared") {
        path = fo.getParentPath() + "/" + fo.getFileUuId();
      }

      const downloadChunk = async (start, remainingChunkSize) => {
        if (errorOccurred) return;
        for (let attempt = 0; attempt <= MAX_CHUNK_RETRIES; attempt++) {
          try {
            const data = await withTimeout(
              fo.getChunk(start, path, dataTask, remainingChunkSize),
              CHUNK_TIMEOUT,
              `Download chunk at offset ${start}`
            );
            if (useNativeFS) {
              await writer.write({ type: "write", position: start, data });
            } else {
              chunks[start] = data;
            }
            return;
          } catch (err) {
            if (attempt < MAX_CHUNK_RETRIES) {
              const delay = Math.min(1000 * Math.pow(2, attempt), 8000);
              console.warn(`Chunk download retry ${attempt + 1}/${MAX_CHUNK_RETRIES} for offset ${start}`);
              await new Promise((r) => setTimeout(r, delay));
              continue;
            }
            errorOccurred = err;
          }
        }
      };

      while (nextOffset < totSize && !errorOccurred) {
        while (activeDownloads < maxConcurrency && nextOffset < totSize) {
          const currentOffset = nextOffset;
          nextOffset += chunkSize;
          const remainingChunkSize = Math.min(chunkSize, totSize - currentOffset);
          activeDownloads++;

          const promise = downloadChunk(currentOffset, remainingChunkSize)
            .then(() => {
              completedChunks++;
            })
            .finally(() => {
              activeDownloads--;
              const index = downloadPool.indexOf(promise);
              if (index > -1) downloadPool.splice(index, 1);
            });

          downloadPool.push(promise);
        }
        if (downloadPool.length > 0) {
          await Promise.race(downloadPool);
        }
      }
      while (downloadPool.length > 0) {
        await Promise.race(downloadPool);
      }
      if (errorOccurred) throw errorOccurred;

      // Finalize file
      if (useNativeFS) {
        await fileStream.close();
      } else {
        const orderedChunks = [];
        const positions = Object.keys(chunks).map(Number).sort((a, b) => a - b);
        for (const position of positions) {
          orderedChunks.push(chunks[position]);
        }

        // Return raw data for zip/folder download callers
        if (returnData) {
          const totalLength = orderedChunks.reduce((sum, c) => sum + c.length, 0);
          const result = new Uint8Array(totalLength);
          let offset = 0;
          for (const chunk of orderedChunks) {
            result.set(chunk, offset);
            offset += chunk.length;
          }
          if (!masterTask) taskManager.addCompletedTask(dataTask, 1);
          return result;
        }

        const blob = new Blob(orderedChunks);
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = currentFileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      }
      if (!masterTask) taskManager.addCompletedTask(dataTask, 1);
    } catch (error) {
      if (error.name === "AbortError") {
        // User cancelled the file picker — silently clean up
        if (!masterTask) taskManager.addCompletedTask(dataTask, 3);
        return;
      }
      if (!masterTask) {
        taskManager.addCompletedTask(dataTask, 2);
      }
      throw error;
    }
  };

  const downloadFile = async () => {
    // console.log("download file is clicked");
    setTaskMonitorVisible(true);
    window.dispatchEvent(new CustomEvent("operationStart"));
    try {
      let fileName = selectedRow.name;
      const dupCurrentPath = currentPath;
      // console.log("current path in download file", currentPath);
      // if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
      //   const newPath = [...dupCurrentPath];
      //   newPath.splice(1, 1);
      //   dupCurrentPath = newPath;
      // }
      if (dupCurrentPath.length === 1) {
        fileName = selectedRow.uuids;
      }
      const formattedPath =
        dupCurrentPath?.length === 0 ? "" : `/${dupCurrentPath?.join("/")}`;
      const fo = await Item.getItem(formattedPath + "/" + fileName);
      if (fo instanceof IzFile) {
        await downloadIzFile(fo, fileName, undefined, dupCurrentPath);
      } else if (fo instanceof IzFolder) {
        const folderName = fo.getFolderName() || selectedRow.name;

        // Use native FS directory picker if available, otherwise download files individually
        let parentDirHandle = null;
        if (window.showDirectoryPicker) {
          try {
            parentDirHandle = await window.showDirectoryPicker();
          } catch (error) {
            if (error.name === "AbortError") return; // User cancelled picker
            throw error;
          }
        }
        if (dupCurrentPath.length === 1 && dupCurrentPath[0] === "external_shared") {
          fo.setFolderName(fo.getUuId());
        }
        const estimatedFolderSize = await computeFolderSize(fo);
        const masterTaskTotalSize = Math.max(estimatedFolderSize || 0, 1);
        const masterTask = new Task(masterTaskTotalSize, `Downloading ${folderName}`, "Downloading");
        masterTask.fileCount = 0;
        masterTask.totalFileCount = 0;
        taskManager.addRunningTask(masterTask);
        try {
          await downloadIzFolder(fo, parentDirHandle, dupCurrentPath, masterTask, folderName);
          masterTask.progress = 100;
          taskManager.addCompletedTask(masterTask, 1);
        } catch (error) {
          taskManager.addCompletedTask(masterTask, 2);
          throw error;
        }
      }
    } catch (error) {
      showToast(`Download failed:${error}`, "error");
      console.error("Failed to get buffer: here !!", error);
    } finally {
      window.dispatchEvent(new CustomEvent("operationEnd"));
    }
  };
  // const handleRestoreFromTrash = async () => {
  //   try {
  //     const sourcePath = "/" + selectedRow.name;
  //     const fo = await Item.getItem(sourcePath, true);
  //     fo.restore();
  //     showToast("File/Folder restored successfully", "success");
  //     fetchData(currentPath);
  //     setMenu({ selectedRow: null, selectedOption: null });
  //   } catch (error) {
  //     showToast(`Restore failed:${error}`, "error");
  //     console.error("Failed to restore object:", error);
  //     setMenu({ selectedRow: null, selectedOption: null });
  //   }
  // };

  const handleMultiSelectedRestore = async () => {
    try {
      const restorePaths = [];

      // Assuming checkedRows contains names of files/folders to restore
      for (const key in checkedRows) {
        if (key) {
          // In trash, files might be stored at root level with their name
          restorePaths.push("/" + key);
        }
      }

      for (const path of restorePaths) {
        const item = await Item.getItem(path, true); // `true` to indicate it's in trash
        await item.restore();
      }

      showToast("Selected items restored successfully", "success");
      fetchData(currentPath); // Refresh UI
      // Trigger global storage refresh so sidebar/profile storage update immediately
      window.dispatchEvent(new CustomEvent("storageUpdated"));
      setCheckedRows({});
      setSelectedModal(null);
    } catch (error) {
      showToast("Error restoring selected items from trash", "error");
      console.error("Restore failed", error);
      setSelectedModal(null);
    }
  };

  const removeSelectedFromTrash = async () => {
    const folderPathArr = [];
    const fileName = currentPath.join("/");
    const keys = Object.keys(checkedRows);

    for (const key of keys) {
      if (key) {
        // making the array with desired path
        folderPathArr.push(
          (fileName.length === 0 ? "" : "/") + fileName + "/" + key
        );
      }
    }

    if (folderPathArr.length === 0) return;

    const masterTask = new Task(keys.length, `Deleting ${keys.length} item(s)`, "Deleting");
    taskManager.addRunningTask(masterTask);

    let successfulCount = 0;
    try {
      for (let i = 0; i < folderPathArr.length; i++) {
        const path = folderPathArr[i];
        const item = await Item.getItem(path, true);
        await item.remove(true); // Permanently delete
        successfulCount++;
        masterTask.progress = Math.min(((i + 1) / keys.length) * 100, 99);
      }

      masterTask.progress = 100;
      masterTask.name = `Deleting ${successfulCount} item(s)`;
      taskManager.addCompletedTask(masterTask, 1);

      showToast("Selected items permanently deleted", "success");
      fetchData(currentPath);
      // Trigger global storage refresh so sidebar/profile storage update immediately
      window.dispatchEvent(new CustomEvent("storageUpdated"));
      setMenu({ selectedRow: null, selectedOption: null });
    } catch (error) {
      if (keys.length > 1) {
        const failed = keys.length - successfulCount;
        masterTask.name = `Deleting ${successfulCount} item(s), ${failed} failed`;
      }
      masterTask.progress = 0;
      taskManager.addCompletedTask(masterTask, 2);
      showToast("Error removing selected items from trash : " + error, "error");

      setMenu({ selectedRow: null, selectedOption: null });
    }
  };

  // const removeAllFromTrash = async () => {

  //   const folderPathArr = [];

  //   // current path will give the array of the all the dir names of out side or the curr directory
  //   const fileName = currentPath.join("/");

  //   filesData.forEach((file) => {
  //     if (file) {
  //       folderPathArr.push(
  //         (fileName.length === 0 ? "" : "/") + fileName + "/" + file.name
  //       );
  //     }
  //   });
  //   try {
  //     for (const path of folderPathArr) {
  //       const item = await Item.getItem(path, true); // `true` to indicate it's in trash
  //       await item.remove(true); // Permanently delete
  //     }
  //     showToast("All items permanently deleted from trash", "success");

  //     fetchData(currentPath);
  //     setMenu({ selectedRow: null, selectedOption: null });
  //   } catch (error) {
  //     showToast("Error removing all items from trash", "error");

  //     setMenu({ selectedRow: null, selectedOption: null });
  //   }
  // };
  // const handleRemoveFromTrash = async () => {

  //   try {
  //     const fileName = selectedRow.name;
  //     const fo = await Item.getItem(fileName, true);
  //     await fo.remove(true);
  //     showToast("File permanently deleted", "success");
  //     fetchData(currentPath);
  //     setMenu({ selectedRow: null, selectedOption: null });
  //   } catch (error) {
  //     showToast(`Remove failed:${error}`, "error");
  //     console.error("Failed to remove from trash object:", error);
  //     setMenu({ selectedRow: null, selectedOption: null });
  //   }
  // };
  const handleOpen = async (row, idx) => {
    if (row?.original?.type === "folder") {
      let folderId = row.original.name;
      // Special case for root level items which might use UUIDs
      if (currentPath.length === 1 && filesData[idx]?.uuids) {
        folderId = filesData[idx].uuids;
      }

      handleFolderClick(folderId);
      setSelectedFolder(folderId);
      handledupFolderClick(row.original.name);
    } else if (row?.original?.type === "file") {
      const selRow = row?.original;
      const fileName = selRow.name;

      try {
        let filePathName = fileName;
        if (currentPath.length === 1) {
          filePathName = filesData[idx]?.uuids || selRow.uuids;
        }

        const formattedPath =
          currentPath?.length === 0 ? "" : `/${currentPath?.join("/")}`;
        const fo = await Item.getItem(formattedPath + "/" + filePathName);
        const fileNameForShared = filePathName;

        if (fo instanceof IzFile) {
          const fileType = fo.getFileType();
          const fileExtension = fileName?.split(".").pop()?.toLowerCase();

          if (fileType === "application/pdf" || fileExtension === "pdf") {
            showToast("Loading PDF...", "info");
            setPdfFo(fo);
            setFileOwner(row.original?.owner ?? "NoData");
            setPdfFileName(fileName);
            setPdfDupCurrentPath(currentPath);
            setShowPDFViewer(true);
            showToast("PDF loaded successfully", "success");
          } else if (fileType === "application/idoc" || fileExtension === "idoc") {
            const normalizedParent = currentPath.join("/");
            const fullPath = `/${normalizedParent}/${fileNameForShared}`.replace(/\/+/g, '/');
            window.open(`${DOCS_APP_URL}?path=${encodeURIComponent(fullPath)}&name=${encodeURIComponent(fileName)}`, "_blank");
          } else if (fileType === "application/isheet" || fileExtension === "isheet") {
            const normalizedParent = currentPath.join("/");
            const fullPath = `/${normalizedParent}/${fileNameForShared}`.replace(/\/+/g, '/');
            window.open(`${SHEETS_APP_URL}?path=${encodeURIComponent(fullPath)}&name=${encodeURIComponent(fileName)}`, "_blank");
          } else if (["jpg", "jpeg", "png", "gif", "svg", "webp"].includes(fileExtension)) {
            setImageFo(fo);
            setFileOwner(row.original?.owner ?? "NoData");
            setImageFileName(fileName);
            setImageDupCurrentPath(currentPath);
            setShowImageViewer(true);
          } else if (["mp3", "wav", "ogg", "m4a", "flac"].includes(fileExtension)) {
            setAudioFo(fo);
            setFileOwner(row.original?.owner ?? "NoData");
            setAudioFileName(fileName);
            setAudioDupCurrentPath(currentPath);
            setShowAudioPlayer(true);
          } else if (["mp4", "webm", "ogv", "mov", "mkv"].includes(fileExtension)) {
            setVideoFo(fo);
            setFileOwner(row.original?.owner ?? "NoData");
            setVideoFileName(fileName);
            setVideoDupCurrentPath(currentPath);
            setShowVideoPlayer(true);
          } else if (COLLABORA_STATE) {
            loadCollobora(selRow);
          }
        }
      } catch (error) {
        showToast(`Failed to load file: ${error}`, "error");
        console.error("Failed to load file:", error);
      }
    }
  };

  const handleRowClick = (row, idx) => {
    if (isMobile) {
      if (isSelectionMode) {
        handleMobileRowClick(row.original.name);
      } else {
        handleOpen(row, idx);
      }
    } else {
      setSelectedFolder(row.original);
    }
  };


  // const truncateName = (name) => {

  //   if (!name) return "";

  //   return name.length > 20 ? `${name.slice(0, 5)}....` : name;

  // };
  const loadCollobora = (selRow) => {
    //  TODO:change this logic when collabora integration is functional
    const idx = selRow.uuids;
    // console.log("selected row is ", selRow, idx);
    const parentPath = currentPath.join("/");
    let filePath = [parentPath, selRow.name]
      .filter(Boolean) // remove empty parts
      .join("/");
    // console.log("active tab is ", filePath);
    if (activeTab === 1) {
      const temp = "shared/" + idx;
      filePath = temp;
    }
    // console.log("slash count is ", filePath);

    const data = {
      filePath: filePath,
      token: localStorage.getItem("izauthtoken"),
      shared: activeTab === 1,
      pin: getPin(),
      email: getEmail()
    };
    const base64Data = btoa(JSON.stringify(data));
    const fileIdEnc = encodeURIComponent(selRow?.uuids);
    const wopiSrc = `${WOPI_URL}/wopi/files/${fileIdEnc}`;
    collaboraURL.current = `${COLLABORA_URL}/browser/dist/cool.html?WOPISrc=${encodeURIComponent(wopiSrc)}&access_token=${base64Data}`;
    setShowCollabora(true);
  };

  return (
    <div className="tabsTableWrapper">
      {!searchQuery && false && (
        <Tabs
          tabsTitles={tabsTitles}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          TabIcons={TabIcons}
          tabIconKeys={tabIconKeys}
          marginBottom="0px"
        />
      )}
      {count > 0 && !isMobile && (
        <div className="actionsIconBox">
          <div className="left">
            <div className="actionsIconBoxCount">{count} items Selected</div>
            <div className="actionsIconBoxWrapper">
              {actionIconTitles.map((title, index) => {
                const isTrash = tabsTitles[activeTab] === "Trash";

                const hasFolderSelected = Object.keys(checkedRows).some(name => {
                  const file = filesData.find(f => f.name === name);
                  return file && file.type === "folder";
                });

                if (title === "copy" && hasFolderSelected) return null;

                const showIcon = isTrash ? index === 5 : index <= 1 || index === 6;
                if (showIcon) {
                  return (
                    <div
                      className="iconBox"
                      key={index}
                      onClick={() => setSelectedModal(title)}
                      style={{ cursor: "pointer" }}
                    >
                      <GetActionIcon
                        type={title}
                        color="var(--text-grey-strong)"
                      />
                    </div>
                  );
                }
              })}
              {/* here is the share */}
              {selectedModal === "share" ? (
                <ShareFiles
                  handleCancel={() => setSelectedModal(null)}
                  sharedData={filteredFilesData}
                  checkedRows={checkedRows}
                />
              ) : selectedModal === "delete" ? (
                <DeleteModal
                  key={filteredFilesData}
                  headerTitle={activeTab + 1 === 3 ? "Delete" : "Move to Trash"}
                  content={activeTab + 1 === 3
                    ? `Are you sure you want to delete ${count} item${count === 1 ? "" : "s"} permanently?`
                    : `Are you sure you want to move ${count} item${count === 1 ? "" : "s"} to the trash?`
                  }
                  handleCancel={() => setSelectedModal(null)}
                  handleSave={() => {
                    if (activeTab + 1 === 3) {
                      removeSelectedFromTrash();
                      setSelectedModal(null);
                    } else {
                      onAllSelectRemove();
                      setSelectedModal(null);
                    }
                  }}
                  selectedModal={selectedModal}
                />
              ) : selectedModal === "copy" ? (
                <MoveFile
                  copied={true}
                  handleCancel={() => {
                    setSelectedModal(null);
                    setCheckedRows({});
                  }}
                  rowData={selectedRow}
                  movedData={filteredFilesData}
                  selectedModal={selectedModal}
                  currentPath={currentPath}
                  UUIDArrays={UUIDArrays}
                  fetchData={fetchData}
                  setCurrentPath={setCurrentPath}
                  selectedFolder={selectedFolder}
                  checkedRows={checkedRows}
                  count={count}
                  taskManager={taskManager}
                  setTaskMonitorVisible={setTaskMonitorVisible}
                  clearSelections={() => {
                    setCheckedRows({});
                  }}

                />
              ) : selectedModal === "moveTo" ? (
                <MoveFile
                  copied={false}
                  handleCancel={() => {
                    setSelectedModal(null);
                    setCheckedRows({});
                  }}
                  rowData={selectedRow}
                  movedData={filteredFilesData}
                  selectedModal={selectedModal}
                  currentPath={currentPath}
                  fetchData={fetchData}
                  setCurrentPath={setCurrentPath}
                  selectedFolder={selectedFolder}
                  checkedRows={checkedRows}
                  count={count}
                  taskManager={taskManager}
                  setTaskMonitorVisible={setTaskMonitorVisible}
                  clearSelections={() => {
                    setCheckedRows({});
                  }}

                />
              ) : selectedModal === "restore" ? (
                <RestoreModal
                  handleSave={handleMultiSelectedRestore}
                  handleCancel={() => setSelectedModal(null)}
                  content={`Are you sure you want to restore ${Object.values(checkedRows).filter((value) => value).length === 1
                    ? "this item"
                    : `these ${Object.values(checkedRows).filter((value) => value).length} items`
                    }?`}
                />
              ) : null}
            </div>
          </div>
          <div
            className="right"
            onClick={() => {
              setCheckedRows({});
            }}
            style={{ cursor: "pointer" }}
          >
            <GetActionIcon type="cross" color="var(--text-grey-strong)" />
          </div>
        </div>
      )}
      {searchQuery && (
        <h3 className="searchCount">Search Result ({filesData.length})</h3>
      )}
      {activeTab + 1 !== 4 && (
        <BreadcrumbExternalShare
          currentPath={currentPath}
          setCurrentPath={setCurrentPath}
          dupCurrentPath={dupCurrentPath}
          activeTab={activeTab}
          setdupCurrentPath={setdupCurrentPath}
        />
      )}
      {/* rename is here */}
      {/* {menu.selectedOption === "Rename" && (
        <RenameFile
          heading="Rename"
          placeholder="Rename the file/folder"
          setMenu={setMenu}
          menu={menu}
          inputWidth="93%"
          handleCancel={cancelHandler}
          handleSave={saveHandler}
          value={rename}
          onChange={changeHandler}
          rowData={selectedRow}
          wrapWidth="100%"
          disabled={rename.length === 0}
        />
      )}
      {menu.selectedOption === "Trash" && (
        <DeleteModal
          content={`Move  “${truncateName(selectedRow.name)}” To Trash?`}
          handleCancel={handleMenu}
          showHeader={false}
          handleSave={moveToTrash}
        />
      )}
      {(menu.selectedOption === "Move to" ||
        menu.selectedOption === "Copy to") && (
          <MoveFile
            copied={
              menu.selectedOption === "Move to"
                ? false
                : menu.selectedOption === "Copy to"
                  ? true
                  : ""
            }
            handleCancel={handleMenu}
            rowData={selectedRow}
            UUIDArrays={UUIDArrays}
            currentPath={currentPath}
            fetchData={fetchData}
            setCurrentPath={setCurrentPath}
            selectedFolder={selectedFolder}
          />
        )} */}

      {/* {menu.selectedOption === "Share" && (
        <ShareProject
          placeHolder=""
          setMenu={setMenu}
          menu={menu}
          handleCancel={handleMenu}
          title={truncateName(selectedRow?.name)}
          selectedFolder={selectedFolder}
          currentPath={currentPath}
        />
      )} */}

      {menu.selectedOption === "Details" && (
        <Files
          handleCancel={handleMenu}
          setMenu={setMenu}
          menu={menu}
          isVisible={true}
          title={selectedRow?.name}
          selectedRow={selectedRow}
          currentPath={currentPath}
          centered={true}
        />
      )}

      {menu.selectedOption === "Versions" && (
        <VersionHistory
          handleCancel={handleMenu}
          setMenu={setMenu}
          menu={menu}
          isVisible={true}
          selectedRow={selectedRow}
          currentPath={currentPath}
          centered={true}
        />
      )}

      {/* {menu.selectedOption === "Restore" && (
        <RestoreModal
          handleCancel={handleMenu}
          content={`Are you sure you want to restore "${truncateName(selectedRow?.name)}"?`}
          handleSave={handleRestoreFromTrash}
        />
      )}

      {menu.selectedOption === "Delete forever" && (
        <DeleteModal
          content={`Are you sure you want to delete "${selectedRow?.name}" permanently?`}
          handleCancel={handleMenu}
          handleSave={handleRemoveFromTrash}
        />
      )}
      {menu.selectedOption == "delete forever trash" && (
        <DeleteModal
          content={"Are you sure you want to delete all the items permanently?"}
          handleCancel={handleMenu}
          handleSave={removeAllFromTrash}
        />
      )} */}

      {activeTab + 1 === 3 && (
        <div className="trashHeader">
          <p className="text" style={{ cursor: "pointer" }}>
            {trashRetentionBanner}
          </p>
          <p
            className="title"
            onClick={() => {
              setMenu((pre) => ({
                ...pre,
                selectedOption: "delete forever trash"
              }));
            }}
          >
            Empty Trash
          </p>
        </div>
      )}
      {filesData.length === 0 ? (
        <div
          className={`nofiles ${dragging ? "dragging" : ""}`}
          onDrop={handleDrop}
          style={{ height: "55vh" }}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
        >
          <div className="addFiles">
            <img src={addFile} alt="add file" />
            <h3 className="title">No Data</h3>
            <p className="content">
              Use the Add button to add files or folders.
            </p>
          </div>
        </div>
      ) : (
        <div
          className="tableContainer"
          style={{
            backgroundColor:
              layout == "grid"
                ? "transparent"
                : theme === "light"
                  ? "white"
                  : "#1C191E",
            paddingTop: "0px",
            overflowY: "auto",
            minHeight: "calc(100vh - 200px)",
            maxHeight: "calc(100vh - 200px)"
          }}
        >
          <table
            className={`table ${layout === "grid" ? "gridTable" : ""}`}
            {...getTableProps()}
          >
            <thead
              className={`tableHead ${layout === "grid" ? "gridTableHead" : ""}`}
            >
              {isMobile ? (
                <tr className="mobile-header">
                  <th className="tableHeadRowHeaderBox">Name</th>
                </tr>
              ) : (
                headerGroups.map((headerGroup) => (
                  <tr
                    className="tableHeadRow"
                    key={headerGroup.id}
                    {...headerGroup.getHeaderGroupProps()}
                  >
                    {headerGroup.headers.map((column) => (
                      <th
                        className="tableHeadRowHeaderBox"
                        style={{
                          width: column.width
                        }}
                        key={column.id}
                        {...column.getHeaderProps()}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))
              )}
            </thead>

            <tbody
              className={`tableBody ${layout === "grid" ? "gridTableBody" : ""}`}
              {...getTableBodyProps()}
              style={{
                backgroundColor:
                  layout === "grid"
                    ? "transparent"
                    : theme === "light"
                      ? "white"
                      : "#1C191E",
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8
              }}
            >
              {rows.map((row, idx) => {
                prepareRow(row);
                // console.log("row,", row);
                // console.log("uuid in filesdata, ", filesData[idx].uuids);
                // console.log("row index:", idx);
                return (
                  <tr
                    className={`tableBodyRow ${isMobile ? "tableBodyMobileRow" : ""
                      } ${layout === "grid" ? "gridTableBodyRow" : ""}`}
                    key={row.id}
                    {...row.getRowProps()}
                    onTouchStart={(e) =>
                      isMobile && (layout === "table" || "grid")
                        ? handleTouchStart(e, row.original.name)
                        : null
                    }
                    onTouchEnd={handleTouchEnd}
                    onTouchMove={handleTouchEnd}
                    style={{
                      backgroundColor: checkedRows[row.original.name]
                        ? "var(--gray-gray-8)"
                        : undefined
                    }}
                    onClick={() => handleRowClick(row, idx)}
                    onDoubleClick={() => handleOpen(row, idx)}
                    onMouseDown={(e) => { if (e.detail > 1) e.preventDefault(); }}
                  >
                    <CollaboraUI collaboraURL={collaboraURL.current} showCollabora={showCollabora} setShowCollabora={setShowCollabora} />

                    {isMobile && layout === "table" ? (
                      <td
                        style={{
                          backgroundColor:
                            checkedRows[row.original.name] && isMobile
                              ? "var(--gray-gray-8)"
                              : undefined
                        }}
                        className="tableBodyRowData"
                      >
                        <div className="mobile-name-scroll" style={{ flex: 1, overflowX: isMobile ? "auto" : "hidden", overflowY: "hidden", display: "flex", alignItems: "center" }}>
                          <span key="name" style={{ whiteSpace: "nowrap" }}>{row.cells[0].render("Cell")} </span>
                        </div>
                        <span key="actions" style={{ flexShrink: 0 }}>
                          {row.cells[1].render("Cell")}{" "}
                        </span>
                      </td>
                    ) : layout === "table" && !isMobile ? (
                      row.cells.map((cell) => (
                        <td
                          style={{
                            width: cell.column.width
                          }}
                          className="tableBodyRowData"
                          key={cell.column.id}
                          {...cell.getCellProps()}
                          onClick={() => setSelectedFolder(row.original)}
                        >
                          {cell.render("Cell")}
                        </td>
                      ))
                    ) : (
                      <td
                        className="gridTableBodyRowData"
                        style={{
                          backgroundColor:
                            checkedRows[row.original.name] &&
                            "var(--gray-gray-8)",
                          minHeight: "180px",
                        }}
                      >
                        <div
                          className="imageBox"
                          style={{
                            backgroundColor:
                              checkedRows[row.original.name] &&
                              "var(--background-bg-normal)"
                          }}
                        >
                          <img
                            src={getFileIcon(row.original.name, row.original.type)}
                            alt="file icon"
                            className="fileIcon"
                          />

                          <div
                            className={`gridCheckbox ${checkedRows[row.original.name] ? "showCheck" : ""
                              }`}
                            style={{
                              pointerEvents: isMobile && "none"
                            }}
                          >
                            <SquareCheckBox
                              label=""
                              isChecked={
                                checkedRows[row.original.name] || false
                              }
                              isDisable={false}
                              onChange={(e) => {
                                setCheckedRows((prev) => {
                                  const updatedCheckedRows = {
                                    ...prev,
                                    [row.original.name]: e.target.checked
                                  };

                                  // Ensure `isAllChecked` only updates when all rows are checked
                                  return updatedCheckedRows;
                                });
                              }}
                            />
                          </div>
                        </div>

                        <div className="infoWrapper">
                          <div className="infoWrapperLeft">
                            <p className="name">{row.original.name}</p>
                            {/* <span className="gridModified">
                              {row.cells[1].render("Cell")}
                            </span> */}
                          </div>
                          <div className="infoWrapperRight">
                            <div className="imgBox">
                              {row.cells[1].render("Cell")}
                            </div>
                          </div>
                        </div>
                      </td>
                    )}

                    {menu.selectedRow == row.id && (
                      <td
                        ref={menuRef}
                        className="menuBox"
                        style={{
                          bottom: !isEnoughSpaceBelow ? "10%" : "auto",
                          top: isEnoughSpaceBelow ? "10%" : "auto",
                          right: isMobile ? "0%" : layout === "grid" ? "-19%" : "5%"
                        }}
                      >
                        <MenuDropDown
                          list={ExternalSpaceList}
                          setMenu={setMenu}
                          row={row?.original}
                          id={row?.id}
                          setSelectedRow={setSelectedRow}
                          downloadFile={downloadFile}
                          restoreFromTrash={() => { }}
                          DeleteFromTrash={() => { }}
                          tableMode={layout}
                        />
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )
      }





      <PDFViewer
        isVisible={showPDFViewer}
        handleCancel={() => {
          setShowPDFViewer(false);
          setPdfFo(null);
          setPdfFileName("");
          setPdfDupCurrentPath([]);
        }}
        fo={pdfFo}
        fileName={pdfFileName}
        dupCurrentPath={pdfDupCurrentPath}
        fileOwner={fileOwner}
      />

      <ImageViewer
        isVisible={showImageViewer}
        handleCancel={() => {
          setShowImageViewer(false);
          setImageFo(null);
          setImageFileName("");
          setImageDupCurrentPath([]);
        }}
        fo={imageFo}
        fileName={imageFileName}
        dupCurrentPath={imageDupCurrentPath}
      />

      <AudioPlayer
        isVisible={showAudioPlayer}
        handleCancel={() => {
          setShowAudioPlayer(false);
          setAudioFo(null);
          setAudioFileName("");
          setAudioDupCurrentPath([]);
        }}
        fo={audioFo}
        fileName={audioFileName}
        dupCurrentPath={audioDupCurrentPath}
      />

      <VideoPlayer
        isVisible={showVideoPlayer}
        handleCancel={() => {
          setShowVideoPlayer(false);
          setVideoFo(null);
          setVideoFileName("");
          setVideoDupCurrentPath([]);
        }}
        fo={videoFo}
        fileName={videoFileName}
        dupCurrentPath={videoDupCurrentPath}
      />
    </div >
  );
};

export default Table;
